import { useTranslation } from "react-i18next";

/**
 * @param {string|string[]} ns - namespace və ya namespace siyahısı (default: common)
 */
export function useAppTranslation(ns = "common") {
  return useTranslation(ns);
}

export default useAppTranslation;
